"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.VersionedIdentifier = exports.IncludeDef = exports.UsingDef = void 0;
var expression_1 = require("./expression");
var UsingDef = /** @class */ (function (_super) {
    __extends(UsingDef, _super);
    function UsingDef() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return UsingDef;
}(expression_1.UnimplementedExpression));
exports.UsingDef = UsingDef;
var IncludeDef = /** @class */ (function (_super) {
    __extends(IncludeDef, _super);
    function IncludeDef() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return IncludeDef;
}(expression_1.UnimplementedExpression));
exports.IncludeDef = IncludeDef;
var VersionedIdentifier = /** @class */ (function (_super) {
    __extends(VersionedIdentifier, _super);
    function VersionedIdentifier() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return VersionedIdentifier;
}(expression_1.UnimplementedExpression));
exports.VersionedIdentifier = VersionedIdentifier;
//# sourceMappingURL=declaration.js.map